<template>
    <div>
        <page-navigate></page-navigate>
        <div id="pageContainer">
            <section class="container1">
                <div class="flex contentBox justify-between ">
                    <div class="left">
                        <h1 class="super_large-72_bold md-title-32_bold word1">贵金属及能源</h1>
                        <h2 class="subtitle-20_regular md-body-14_regular word2">
                            交易黄金、原油和天然气等，通过多元投资组合，对冲经济周期波动
                        </h2>
                        <a :href="signupUrl" target="_blank">
                            <div class="pageBtn primary-default_large">
                                <span class="word3">立即开户</span>
                                <span class="iconfont icon-right"></span>
                            </div>
                        </a>
                    </div>
                    <img class="right" src="@/assets/image/trading-product/tradingproductCommodity.png" alt="" />
                </div>
            </section>
            <product-tab></product-tab>
            <section class="container2">

                <div class="contentBox container2Content">
                    <h2 class="text-center title-48_bold md-title-24_bold scroll-fade-up word4 scroll-fade-up">产品优势</h2>
                    <h3 class="text-center subtitle-20_regular md-footnote-regular_12 word5 scroll-fade-up">
                        极具竞争力点差，将抗通胀和避险资产纳入您的投资组合，驾驭市场周期
                    </h3>
                    <a href="https://edocs-1305385874.cos.ap-hongkong.myqcloud.com/web/EBC PRODUCT GUIDE_CN.pdf"
                        target="_blank">
                        <div class="primary-default_large jyBtn scroll-fade-up">交易产品指南</div>
                    </a>
                    <div class="topCardList flex scroll-fade-up">
                        <div class="card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34"
                                fill="none">
                                <g clip-path="url(#clip0_2526_24714)">
                                    <path
                                        d="M3.06339 28.2818V23.9113C3.06339 23.7548 3.03557 23.5983 2.98342 23.4488C2.49664 22.0754 0.0836347 14.5652 2.08636 10.9144C4.29075 6.89156 8.27882 0.911194 8.27882 0.911194C8.27882 0.911194 11.0986 1.79782 9.14806 5.2852L7.03755 8.74825M6.54038 16.0078V8.74448C6.54038 8.74448 9.53057 9.1791 9.53057 11.7868C9.53057 13.7374 9.64183 14.93 10.0243 16.4981C10.1564 17.0405 10.4276 18.3896 10.6258 19.3979C10.7823 20.1976 11.0326 21.192 10.8101 21.9778L10.0208 24.0709V28.5457M1.3039 33.0832V28.737H11.7556V33.0832H1.3039Z"
                                        stroke="#9F734C" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M31.7377 28.2818V23.9113C31.7377 23.7548 31.7655 23.5983 31.8177 23.4488C32.3044 22.0754 34.7174 14.5652 32.7147 10.9144C30.5103 6.88808 26.5223 0.907715 26.5223 0.907715C26.5223 0.907715 23.7025 1.79434 25.653 5.28172L27.7635 8.74477M28.2609 16.0078V8.74446C28.2609 8.74446 25.2708 9.17908 25.2708 11.7868C25.2708 13.7374 25.1595 14.93 24.777 16.4981C24.6449 17.0405 24.3737 18.3895 24.1755 19.3979C24.0191 20.1976 23.7687 21.192 23.9912 21.9778L24.7805 24.0709V28.5457M23.0454 33.0832V28.737H33.4971V33.0832H23.0454Z"
                                        stroke="#9F734C" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M23.0041 9.18315C23.0041 9.18315 23.0041 9.21792 23.0041 9.23531C20.1008 9.60039 17.8025 11.8987 17.4375 14.8019C17.4201 14.8019 17.4027 14.8019 17.3888 14.8019C17.3714 14.8019 17.354 14.8019 17.3366 14.8019C16.9715 11.8987 14.6733 9.60039 11.77 9.23531C11.77 9.21792 11.77 9.20054 11.77 9.18315C11.77 9.16577 11.77 9.14838 11.77 9.131C14.6698 8.76592 16.9715 6.46765 17.3366 3.56439C17.354 3.56439 17.3714 3.56439 17.3888 3.56439C17.4062 3.56439 17.4235 3.56439 17.4375 3.56439C17.8025 6.46765 20.1008 8.76592 23.0041 9.131C23.0041 9.14838 23.0041 9.16577 23.0041 9.18315Z"
                                        stroke="#A52933" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_2526_24714">
                                        <rect width="33.0624" height="33.0415" fill="white"
                                            transform="translate(0.869629 0.476929)" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <h3 class="title-24_medium md-body-16_medium word6">品种齐全</h3>
                            <div class="desc content-16_regular md-footnote-regular_12 word7">覆盖主流大宗商品</div>
                        </div>
                        <div class="card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40"
                                fill="none">
                                <path d="M32.2366 30.9487H8.34814V34.7402H32.2366V30.9487Z" stroke="#9F734C"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M16.245 10.0127L8.34814 12.3469L10.0135 11.8555L18.7328 9.30627"
                                    stroke="#9F734C" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M32.2356 5.25916L24.4275 7.56609L23.2808 7.90394L30.6555 5.72669L30.4951 5.80176L21.7759 8.351"
                                    stroke="#9F734C" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M20.2925 10.0638V30.9491" stroke="#9F734C" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M20.2988 10.0637C21.0093 10.0637 21.5853 9.48771 21.5853 8.77716C21.5853 8.06661 21.0093 7.4906 20.2988 7.4906C19.5882 7.4906 19.0122 8.06661 19.0122 8.77716C19.0122 9.48771 19.5882 10.0637 20.2988 10.0637Z"
                                    stroke="#A52933" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M12.2252 19.5002C12.1808 21.6058 10.4608 23.2882 8.34842 23.2882C6.236 23.2882 4.50921 21.6058 4.46826 19.4968"
                                    stroke="#A52933" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M12.2344 19.4965C10.0879 19.4965 8.34401 17.7561 8.34401 15.6061C8.34401 17.7527 6.60357 19.4965 4.45361 19.4965"
                                    stroke="#9F734C" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M36.1134 12.6749C36.069 14.7805 34.349 16.4629 32.2366 16.4629C30.1242 16.4629 28.4008 14.7771 28.3599 12.6715"
                                    stroke="#A52933" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M36.1231 12.6745C33.9765 12.6745 32.2327 10.934 32.2327 8.78406C32.2327 10.9306 30.4922 12.6745 28.3423 12.6745"
                                    stroke="#9F734C" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <h3 class="title-24_medium md-body-16_medium word8">灵活的杠杆</h3>
                            <div class="desc content-16_regular md-footnote-regular_12 word9">
                                杠杆高达500:1
                            </div>
                        </div>
                        <div class="card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40"
                                fill="none">
                                <path d="M20.5706 31.4919V34.6666M12.2788 34.6666H29.2669" stroke="#9F734C"
                                    stroke-linecap="round" />
                                <path
                                    d="M11.7792 10.0793C10.3171 11.9442 9.44775 14.2796 9.44775 16.8142C9.44775 22.9201 14.4929 27.8699 20.7164 27.8699C26.9399 27.8699 31.9851 22.9201 31.9851 16.8142C31.9851 14.2796 31.1158 11.9442 29.6536 10.0793"
                                    stroke="#9F734C" stroke-linecap="round" />
                                <path
                                    d="M12.001 5.49951C8.45873 8.1099 6.16748 12.266 6.16748 16.947C6.16748 24.8492 12.6968 31.2552 20.7512 31.2552C28.8055 31.2552 35.3349 24.8492 35.3349 16.947C35.3349 12.266 33.0436 8.1099 29.5014 5.49951"
                                    stroke="#9F734C" stroke-linecap="round" />
                                <path
                                    d="M28.0164 16.3695C28.0164 16.3903 28.0164 16.412 28.0154 16.4328C24.3285 16.888 21.4065 19.7548 20.9425 23.3721C20.9214 23.3731 20.9003 23.3731 20.8792 23.3731C20.8569 23.3731 20.8348 23.3731 20.8136 23.3721C20.3497 19.7546 17.4277 16.888 13.7417 16.4328C13.7407 16.4121 13.7407 16.3904 13.7407 16.3695C13.7407 16.3488 13.7407 16.327 13.7417 16.3062C17.4277 15.8512 20.3497 12.9856 20.8136 9.36811C20.8348 9.36713 20.8569 9.36713 20.879 9.36713C20.9001 9.36713 20.9213 9.36713 20.9424 9.36811C21.4064 12.9854 24.3283 15.8512 28.0153 16.3062C28.0163 16.327 28.0164 16.3488 28.0164 16.3695Z"
                                    stroke="#A52933" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <h3 class="title-24_medium md-body-16_medium word10">超低的点差</h3>
                            <div class="desc content-16_regular md-footnote-regular_12 word11">低点差交易更省成本</div>
                        </div>

                    </div>
                    <h2 class="text-center title-48_bold md-title-24_bold scroll-fade-up">市场报价</h2>
                    <div id="pageOverLay"></div>
                    <product-module-new />
                </div>
            </section>
            <open-account></open-account>
            <section class="container4 commonQuestion">
                <div class="contentBox">
                    <h2 class="scroll-fade-up">常见问题</h2>
                    <div class="QA-list">
                        <div class="QA-item">
                            <div class="QA-title">1、什么是商品CFD？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    商品(Commodities)
                                    是可以买卖的，并可被投入到实际的产品生产和服务中的原材料。
                                </p>
                                <p class="QA-li">
                                    它们与全球经济、工业生产等高度相关，且独立于股票行情，是对冲风险和多元化投资的重要品种。
                                </p>
                                <p class="QA-li">
                                    通过EBC，您无需直接买卖商品，即可透过最具极具流动性的市场参与全球商品交易，实现多元化投资组合。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">2、商品CFD可以交易什么？</div>
                            <div class="QA-content">
                                <p class="QA-li">商品主要分为2类：</p>
                                <p class="QA-li">
                                    硬商品：金属（黄金、白银、铜）和能源产品（原油、天然气）可以从自然界开采或提取，被称为“硬商品”。它们与全球经济和工业生产等高度相关，也是全球交易量最大的商品之一。
                                </p>
                                <p class="QA-li">
                                    软商品：玉米、大豆、可可、牲畜及其他农作物等种植或生产的产品，不需要提取或者开采，被称为“软商品”。软商品大多是农产品，在套期保值中发挥着重要作用。
                                </p>
                                <p class="QA-li">
                                    就交易量而言，黄金是最受欢迎的大宗商品，因其天然的价值属性和避险功能，在交易市场极为活跃；原油是全球交易量最大的能源产品。
                                </p>
                            </div>
                        </div>

                        <div class="QA-item">
                            <div class="QA-title">3、商品交易时段</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    黄金、白银等贵金属市场于周一凌晨 1 点开盘，周五午夜（24
                                    点）收盘。每天24:00至凌晨 1:00之间有1个小时休市的时间。
                                </p>
                                <p class="QA-li">
                                    英国布伦特原油于周一凌晨3点开盘，周五午夜（24
                                    点）收盘。每天24:00至凌晨3:00之间有3小时休市的时间。
                                </p>
                                <p class="QA-li">
                                    天然气和美原油于周一凌晨 1 点开盘，周五午夜（24
                                    点）收盘。每天24:00至凌晨1:00之间有1小时休市的时间。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">4、商品交易的点值</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    商品交易中的点值，是一标准手商品，每波动一个点（point）对应的价值。
                                </p>
                                <p class="QA-li">
                                    黄金（XAU）点值对应的是报价小数点后两位，也就是0.01，比如黄金从1874.52波动至1874.53就是1个点。一标准手黄金每波动1个点，账户对应的盈亏是1美元。
                                </p>
                                <p class="QA-li">
                                    白银（XAG）点值对应的是报价小数点后三位，也就是0.001，比如白银从22.466波动至22.467就是1个点。一标准手白银每波动1个点，账户对应的盈亏是5美元。
                                </p>
                                <p class="QA-li">
                                    天然气（XNG）点值对应的是报价小数点后四位，也就是0.0001；原油（XTI）点值对应的是报价小数点后三位，也就是0.001。
                                    在决定交易前，一定要了解不同品种的点值。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">5、如何交易黄金？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    黄金作为价格之锚，是全球公认的“硬通货”。在不确定性环境下，黄金往往是风险规避和寻求资产增值保值的主要投资标的。
                                </p>
                                <p class="QA-li">
                                    黄金对于利率端较为敏感，并且往往与美元走势呈反向关系。比如，当美联储加息的时候，美元升值的预期会打压黄金需求。
                                </p>
                                <p class="QA-li">
                                    另外，黄金与市场对于经济的预期直接相关。比如，美国两年期收益率曲线和十年期收益率曲线倒挂会引发市场对于经济的衰退预期，带动金价走高。
                                </p>
                                <p class="QA-li">
                                    作为一种实物资产，黄金同样与市场供需关系直接相关。通常市场实物需求增加也会带动金价走高。常见的追踪指标包括黄金ETF，通过追踪市场持仓量的变化体现市场的需求。
                                </p>
                                <p class="QA-li">
                                    EBC每日提供黄金ETF实时追踪数据和分析报告，并依深度的流动性为交易黄金提供极具竞争力的点差。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">6、如何交易原油？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    原油作为大宗商品之王，与经济周期和生产周期高度相关。
                                </p>
                                <p class="QA-li">
                                    影响原油价格的首要因素就是市场供需关系。一般来说，如果原油产量增加超出市场的需求预期，油价就会走低。追踪原油产量通常需要关注原油钻井数据和卡特尔组织OPEC的产量变化。
                                </p>
                                <p class="QA-li">
                                    另外，作为一种顺周期的商品，当经济处于扩张期，原油需求通常会扩大，从而推动价格走高，反之打压油价。
                                </p>
                                <p class="QA-li">
                                    值得注意的是，原油并非是完成品，还容易受到相关产业链的影响。比如炼厂开工率，如果开工率不足，会导致成品油价格上升，从而推动炼厂的原油需求；另外，像汽车等和原油高度相关产品的需求也会直接影响原油的价格。
                                </p>
                                <p class="QA-li">
                                    在EBC，透过进入全球最大的原油交易市场，无需直接购买原油，即可灵活的调整交易结构，把握市场交易机遇。
                                </p>
                            </div>
                        </div>

                    </div>
                    </div>
            </section>
        </div>
        <message-v3></message-v3>

        <page-footer></page-footer>
    </div>
</template>

<script>
import fadeAnimate from "../mixins/fadeAnimate.js";
import {
    mapGetters,
} from 'vuex'
export default {
    mixins: [fadeAnimate],
    data() {
        return {
            infoData: "",
            newData: "",
            pagIndex: 0,
            num: 3,
            newsdisplay: "none"
        }
    },
    computed: {
        ...mapGetters([
            'signupUrl',
        ]),
    },
    destroyed() {
    },

    mounted() {
        this.initPage()
    },
    methods: {
        initPage() {
            const setTabActIdx = (idx, e) => {
                scrollTabElement.forEach((item, index) => {
                    item.classList.remove("active");
                });
                floatTabElement.forEach((item, index) => {
                    item.classList.remove("active");
                });
                floatTabElement[idx].classList.add("active");
                scrollTabElement[idx].classList.add("active");
                const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
                const leftPad = 32 * rem;
                const wrapper = document.querySelector(".scrollTabWrapper");
                wrapper.scrollLeft = idx <= 1 ? 0 : e.target.offsetLeft - leftPad;
            };
            const scrollTabElement = document.querySelectorAll(
                ".scrollTabWrapper .tabItem"
            );
            const floatTabElement = document.querySelectorAll(".floatTab .tabItem");
            floatTabElement.forEach((item, idx) => {
                item.addEventListener("click", function (e) {
                    jumpPage(idx);
                });
            });
            scrollTabElement.forEach((item, idx) => {
                item.addEventListener("click", function (e) {
                    jumpPage(idx);
                });
            });
            let tabIndex = 0;

            if (location.href.includes("/commodity/")) {
                tabIndex = 1;
            } else if (location.href.includes("/index-cfds/")) {
                tabIndex = 2;
            } else if (location.href.includes("/share-cfds/")) {
                tabIndex = 3;
            } else if (location.href.includes("/etf/")) {
                tabIndex = 4;
            } else if (location.href.includes("/crypto/")) {
                tabIndex = 5;
            }
            setTabActIdx(tabIndex, { target: floatTabElement[tabIndex] });
            setTabActIdx(tabIndex, { target: scrollTabElement[tabIndex] });
            function jumpPage(idx) {
                const pathArr = location.pathname.split("/");
                const len = pathArr.length;
                const targetArr = ["forex", "commodity", "index-cfds", "share-cfds", "etf", 'crypto'];
                pathArr[len - 2] = targetArr[idx];
                location.href = pathArr.join("/");
            }
            debugger
            console.log(ProductVM,1111)
            ProductVM.changeHandle(tabIndex);
            document.addEventListener("mountedSuccess", (e) => {
                ProductVM.changeHandle(tabIndex);
            });


          
        }
    }
}

</script>
<style scoped lang="scss">
@import url("../assets/css/commonQuestion.scss");

* {
    font-family: Inter, Noto Sans Sc, sans-serif;
}

.message-new .gender-btn::before {
    box-sizing: border-box;
}

.message-new {
    max-width: 1200rem;
    padding-inline: calc((100vw - 1200rem) / 2) !important;
    box-sizing: content-box;
}

.message-new .p1 {
    font-size: 48rem !important;
    line-height: 56rem !important;
}

.contentBox {
    max-width: 1200rem;
    margin-inline: auto;
}

body.no-scroll {
    overflow: hidden;
}

#pageOverLay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
    display: none;
    opacity: 0;
    transition: opacity 0.6s ease;
}

.pageContainer {
    position: relative;
}

#pageContainer {
    background: var(--ebc-neutral-bg_a)
}

#pageContainer .pageBtn {
    gap: 4rem;
    min-width: 180rem;
    width: fit-content;
    cursor: pointer;
}

#pageContainer a {
    width: fit-content;
    display: block;
    margin-inline: auto;
}

.container1 {
    padding-top: calc(80px + 15rem);
    height: 560rem;
    background: var(--ebc-neutral-bg_c);
}

.container1 .left {
    flex: 0 0 770rem;
}

.container1 .left h2 {
    margin: 24rem 0 64rem;
    color: var(--ebc-text-secondary);
}


.container1 .right {
    height: 412rem;
}

.container1 a {
    margin: 0 !important;
}

@media (max-width: 996px) {
    html {
        overflow-x: hidden;
    }

    body {
        overflow-x: visible !important;
    }

    .message-new .p1 {
        font-size: 48rem !important;
        line-height: 72rem !important;
    }

    .container1 {
        padding: 80rem 32rem;
        height: auto;
        overflow-x: hidden;
    }

    .container1 .right {
        /* width: 586rem; */
        height: 586rem;
        margin: 0 auto 80rem;
    }

    .container1>div {
        flex-direction: column;
    }

    .container1 .left {
        order: 2;
        text-align: center;
        flex: 1;
    }

    .container1 .left h2 {
        margin-top: 16rem;
    }

    #pageContainer .container1 a {
        width: 100%;
    }

    #pageContainer .container1 .left .pageBtn {
        width: 100%;
    }

}


.container2 {
    background: var(--ebc-neutral-bg_a);
    margin-top: -64rem;
}

.pt .floatTab,
.es .floatTab {
    width: 900rem;
}

.floatTab {
    position: sticky;
    transform: translateY(-50%);
    z-index: 98;
    top: 128px;
    margin-inline: auto;
    background: var(--ebc-basecolor-white-85);
    border-radius: var(--ebc-corner-radius-full);
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.05);
    backdrop-filter: blur(10px);
    padding: 4rem;
    gap: 8rem;
    width: 792rem;
    height: 64rem;
}

.floatTab .tabItem {
    flex: 1;
    color: var(--ebc-text-secondary);
}

.floatTab .active {
    border-radius: var(--ebc-corner-radius-full);
    background: var(--ebc-neutral-bg_c);
    color: var(--ebc-text-primary);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-weight: 500;
}

.container2 .container2Content {
    padding: 120rem 0;
}

/* .container2 .container2Content>a:last-of-type{
  display:none!important
} */

.container2 h2 {
    margin-bottom: 16rem;
}

.tradingProductPage .container2 h2 {
    max-width: 850rem;
    margin-inline: auto;
}

.container2 h3 {
    max-width: 850rem;
    margin-inline: auto !important;
}

.container2 h3 {
    margin: 16rem 0;
    color: var(--ebc-text-secondary);
}

.container2 .pageBtn {
    margin: 60rem auto 0;
}

@media (max-width: 996px) {
    html {
        height: auto !important;
        min-height: auto !important;
    }

    .container2 {
        padding: 0 32rem;
        margin-top: 0;
    }

    .container2 .container2Content .btnTop {
        height: 64rem;
        font-size: 28rem;
        gap: 8rem;
        line-height: 44rem;
    }

    .container2 .pageBtn {
        height: 80rem;
        font-size: 28rem;
        line-height: 44rem;
        margin-top: 80rem;
    }

    .floatTab {
        display: none !important;
    }

    .container2 .container2Content {
        padding: 64rem 0 160rem;
    }

    .container2 h3 {
        margin: 16rem 0;
    }

    .scrollTab {
        display: inline-flex;
        gap: 16rem;
        min-width: fit-content;
    }

    .scrollTabWrapper {
        overflow-x: auto;
        scroll-behavior: smooth;
        padding: 16rem 32rem;
        margin-top: 64rem;
        background: var(--ebc-neutral-bg_a);
        position: sticky;
        top: 44px;
        z-index: 99
    }

    .scrollTabWrapper::-webkit-scrollbar {
        display: none;
    }

    .scrollTab .tabItem {
        color: var(--ebc-text-secondary);
        padding: 16rem 32rem;
        flex: 1;
        background: var(--ebc-neutral-bg_b);
        border-radius: var(--ebc-corner-radius-full);
        white-space: nowrap;
    }

    .scrollTab .active {
        background: var(--ebc-basecolor-active-500);
        color: var(--ebc-text-primary_white);
        font-weight: 500;
    }
}




.container1{
  padding-top: 110rem
}
.container1 .left{
  flex: 0 0 605rem;
  padding-top: 50rem;
}
.container1 .contentBox{
  align-items: flex-start;
}
.container1 .right{
  height: 367rem;
}
@media (min-width:996px) {
  .es .container1 h1 {
    white-space: nowrap;
  }
  .mn .container1 h1{
    font-size: 60rem;
    white-space: nowrap;
    line-height: 68rem;
  }
}
@media (max-width: 996px) {
  .container1 {
    padding-top:80rem;
  }
  .container1 .left{
    flex:1;
    padding-top: 0;
  }
  .container1 .right{
    height:422rem;
    margin-bottom: 80rem;
  }
}

.container2 h3{
  margin:16rem 0 60rem;
}
.container2 .contentBox {
  padding-top: 88rem;
}

.container2 .topCardList {
  margin-bottom:120rem;
  gap:24rem;
  align-items: stretch;
}

.container2 .topCardList .card {
  flex:1;
  border-radius: var(--ebc-corner-radius-rc16);
  background: var(--ebc-neutral-bg_b);
  padding:32rem 24rem;
  border:0;
}
.container2 .topCardList .card h3{
    width: 100%;
  margin:16rem 0;
  color: var(--ebc-text-primary);
}

.container2 .topCardList .card div{
  color: var(--ebc-text-secondary);
}
.container2 .jyBtn{
  margin-bottom: 60rem;
  min-width: 180rem;
}
@media (max-width: 996px) {
  .container2 .jyBtn{
    height: 80rem;
  margin-bottom: 80rem;
  min-width: unset;
  font-size: 28rem;
  line-height: 44rem;
  font-weight: 500;
}
  .container2 .topCardList{
    margin-bottom: 160rem;

      gap: 32rem;
      flex-wrap: wrap;
  }
  .container2 .topCardList .card h3{
  margin:0rem 0 8rem;
  color: var(--ebc-text-primary);
}

.container2 .topCardList .card {
  padding:32rem;
  padding-left: 128rem;
  flex:1 0 100%;
  position: relative;
}
.container2 .topCardList .card svg{
  position: absolute;
  left: 32rem;
  top: 50%;
  transform: translateY(-50%);
  width: 64rem;
  height: 64rem;
}
}
</style>